import React from 'react';
import PropTypes from 'prop-types';
import Reply from './Reply';

const RepliesList = ({ replies, loggedInUser, toggleLike, deleteReply, reportReply, toggleReply }) => (
  <ul className="replies-list faux-list no-margin-list">
    {replies &&
      replies.map(reply => (
        <li key={reply.id}>
          <Reply
            reply={reply}
            loggedInUser={loggedInUser}
            toggleLike={toggleLike}
            deleteReply={deleteReply}
            reportReply={reportReply}
            toggleReply={toggleReply}
          />
        </li>
      ))
    }
  </ul>
);

RepliesList.propTypes = {
  replies: PropTypes.array,
  loggedInUser: PropTypes.object,
  toggleLike: PropTypes.func,
  deleteReply: PropTypes.func,
  reportReply: PropTypes.func,
  toggleReply: PropTypes.func,
};

export default RepliesList;



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/RepliesList.js